export default "__VITE_ASSET__eb2fe6d3__"